import { IFeatureFlagResponse } from "@modules/eirCustomersFacade/interfaces/responses";
import { IFeatureFlag } from "@modules/eirCustomersFacade/interfaces";

export const mapFeatureFlag = (response: IFeatureFlagResponse): IFeatureFlag => ({
    featureName: response.name,
    isEnabled: response.enabled,
});
